<template>
  <ul class="listCampaing p-0 m-0">
    <li v-for="(item, index) in list" :key="`${item.campaignId}-${index}`" @click="routeTo(item)" class="listCampaing__item">
      <div class="d-flex justify-content-between align-content-center align-items-center bg-white px-4 py-2">
        <p class="m-0" style="max-width: 250px; width: 100%">{{ item.name }}</p>

        <div v-if="showDetailList" class="d-flex align-items-center w-100">
          <div class="w-100 ml-5" style="max-width: 170px">
            <CBadge
              v-if="item.campaignStatus != 'Calculating'"
              class="font-weight-normal px-3 py-2 font-base"
              :class="'badge-' + item.campaignStatus"
              >{{ $t(`general.status.campaign.${item.campaignStatus.toLowerCase()}`) }}</CBadge
            >
          </div>

          <!-- <div class="w-100" v-if="item.recepients > 0">
            <div class="font-smaller font-weight-normal mr-2 text-uppercase font-sm">
              RECIPIENTS: <b class="font-base">{{ item.recepients }}</b>
            </div>
          </div> -->

          <div class="font-weight-normal text-center d-flex justify-content-end align-items-center w-100">
            <CIcon
              v-for="(channel, index) in item.channels"
              :key="channel + index"
              :name="channel"
              class="mx-1"
              size="custom-size"
              :height="23"
              viewBox="0 0 32 32"
            />
          </div>
        </div>
        <div v-if="hasEditIcons">
          <span class="editDraft">{{ $t('home.drafts.edit') }}</span>
          <CIcon name="editFull" size="custom-size" :height="13" viewBox="0 0 32 32" />
        </div>
         
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'listCampaign',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    hasEditIcons: {
      type: Boolean,
      default: () => false,
    },
    showDetailList: {
      type: Boolean,
      default: () => false,
    },
  },

  methods: {
    routeTo(item) {
      switch (item.campaignStatus) {
        // ? Nessas condições envia para a tela de edição
        case 'Draft':
          this.$router.push({ name: 'campaignCreator', params: { campaignId: item.id } })
          break
        case 'Scheduled':
        case 'Ready-to-Send':
        case 'Balance-Updated':
          this.$router.push({ name: 'campaignSummary', params: { campaignId: item.id } })
          break
        // ? Nessas condições envia para tela de resultado
        case 'Sent':
        case 'On-going':
          this.$router.push({ name: 'campaignResult', params: { campaignId: item.id } })
          break
        case 'Calculating':
          break
        case 'Pending-Balance':
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.listCampaing {
  &__item {
    cursor: pointer;
    background: var(--white);
    cursor: pointer;
    padding: 1px;
    border-radius: 2px;
    > div {
      transition: all 300ms;
      box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.03);
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      color: var(--gray-600);
      transform: scale(0.999);
      min-height: 55px;
      &:hover {
        color: var(--gray-700);
        background: var(--white);
        transform: scale(1);
        box-shadow: 10px 5px 16px rgba(0, 0, 0, 0.1) !important;
      }
    }
    &:hover + li {
      > div {
        border-bottom: 1px solid rgba(0, 0, 0, 0.04);
        box-shadow: inset 2px 6px 10px 0 rgba(0, 0, 0, 0.04);
      }
    }
  }
}

  .editDraft{
    margin-right: 7px;
  }

  .editDraft:hover{
    text-decoration: underline;
  }
</style>
